import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_containers/agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchTemplates(customer_id, agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_templates/${agro_exporter_process_id}/${container_id}`
    );
  },

  fetchContainer(customer_id, agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_templates/container/${agro_exporter_process_id}/${container_id}`
    );
  }
};
